// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/course.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./images/book-icon.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
    text-align: center;
}

.App-logo {
    height: 40vmin;
    pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
    .App-logo {
        animation: App-logo-spin infinite 20s linear;
    }
}

.App-header {
    background-color: #282c34;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: white;
}

.App-link {
    color: #61dafb;
}

@keyframes App-logo-spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

table {
    border-collapse: collapse;
    width: 100%;
}

th, td {
    padding: 10px 4px 10px 4px;
    text-align: left;
    border-bottom: 1px solid rgb(243, 242, 242);
    color: #777171;
    text-align: center;
    font-weight: 400;
}

tr:hover {
    background-color: rgba(230, 244, 234, 0.4);
}

.table-back {

    margin-top: 10px;
    margin-top: 10px;
    padding: 15px 10px 35px 10px;
    background: #FFFFFF;
    box-shadow: 0px 0px 4px rgb(243, 242, 242);
}

.tab-background {
    background-color: white;
    padding: 24px;
    height: 70vh;
    overflow-y: overlay;
}

#components-layout-demo-top-side .logo {
    float: left;
    width: 120px;
    height: 31px;
    margin: 16px 24px 16px 0;
    background: rgba(255, 255, 255, 0.3);
}

.ant-row-rtl #components-layout-demo-top-side .logo {
    float: right;
    margin: 16px 0 16px 24px;
}

#components-layout-demo-custom-trigger .trigger {
    padding: 0 24px;
    font-size: 18px;
    line-height: 64px;
    cursor: pointer;
    transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
    color: #1890ff;
}

#components-layout-demo-custom-trigger .logo {
    height: 32px;
    margin: 16px;
    background: rgba(255, 255, 255, 0.3);
}

.site-layout .site-layout-background {
    background: #fff;
}

.details-layout {
    height: 150px;
    background-color: rgb(73, 84, 94);
}

.course-background {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    /* background-position: center; */
    background-size: cover;
    background-repeat: no-repeat;
}

.b-icon {
    height: 120px;
    width: 120px;
    position: absolute;
    top: -4.3rem;
    left: 50%;
    transform: translateX(-50%);
    display: block;
    margin: auto;
    border-radius: 50%;
    border: 0.4rem solid #f7f7f7;
    box-shadow: 1px 0px 10px rgb(0 0 0 / 30%);
    overflow: hidden;
    padding: 0 !important;
    background: #fff;

}

.book-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: cover;
    background-repeat: no-repeat;
}

.b-background {
    position: relative;
    text-align: center;
    min-height: 8rem;
}

.b-body {
    position: relative;
    padding-top: 4rem;
}

.radius-btn, .rounded-btn {
    min-width: 100px;
    border-radius: 20px;
    font-size: 10px;
    font-weight: 700;
    text-align: center;
    padding: 5px 10px;
    /* border: 1px solid #ededed; */
    box-shadow: 1px 1px 3px 0 rgba(145, 108, 108, 0.3);
    text-transform: uppercase;
}

.active-btn, .open-btn, .delivered-btn, .paid-btn {
    color: #0e8c30;
    background-color: rgb(239, 255, 244);
}

.inactive-btn, .close-btn, .cancelled-btn, .unpaid-btn, .deleted-btn {
    color: #d1011d;
    background-color: #feeeed;
}

.details-area {
    overflow: auto;
    height: calc(100vh - 240px);
}

.site-page-header {
    border-bottom: 1px solid rgb(235, 237, 240);
}

.inner-body {
    margin-top: 25px;
    overflow-y: scroll;
    overflow-x: hidden;
    height: calc(100vh - 220px);
}

.single {
    display: flex;
    justify-content: space-between;
    line-height: 20px;
    margin-bottom: 10px;
    color: "gray";
    margin-left: 10px;
}

.single .info-desc {
    width: 50%;
    float: left;
    text-align: left;
}

.info-name {
    color: gray;
    font-weight: 600;
}


/*new code*/

.paginationBttns {
    width: 100%;
    height: 40px;
    list-style: none;
    display: flex;
    justify-content: right;
}

.paginationBttns a {
    padding: 10px;
    margin: 1px;
    border: 1px solid #2b2eff;
    color: #2b2eff;
    cursor: pointer;
}

.paginationBttns a:hover {
    color: white;
    background-color: #2b2eff;
}

.paginationActive a {
    color: white;
    background-color: #2b2eff;
}

.paginationDisabled a {
    color: white;
    background-color: gray;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI;QACI,4CAA4C;IAChD;AACJ;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,2CAA2C;IAC3C,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;;IAEI,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,wBAAwB;IACxB,oCAAoC;AACxC;;AAEA;IACI,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,iCAAiC;AACrC;;AAEA;IACI,yDAA6C;IAC7C,iCAAiC;IACjC,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;IAC5B,yCAAyC;IACzC,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;;AAEpB;;AAEA;IACI,yDAAgD;IAChD,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;IAC/B,kDAAkD;IAClD,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;;AAGA,WAAW;;AAEX;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B","sourcesContent":[".App {\n    text-align: center;\n}\n\n.App-logo {\n    height: 40vmin;\n    pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n    .App-logo {\n        animation: App-logo-spin infinite 20s linear;\n    }\n}\n\n.App-header {\n    background-color: #282c34;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-size: calc(10px + 2vmin);\n    color: white;\n}\n\n.App-link {\n    color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n}\n\ntable {\n    border-collapse: collapse;\n    width: 100%;\n}\n\nth, td {\n    padding: 10px 4px 10px 4px;\n    text-align: left;\n    border-bottom: 1px solid rgb(243, 242, 242);\n    color: #777171;\n    text-align: center;\n    font-weight: 400;\n}\n\ntr:hover {\n    background-color: rgba(230, 244, 234, 0.4);\n}\n\n.table-back {\n\n    margin-top: 10px;\n    margin-top: 10px;\n    padding: 15px 10px 35px 10px;\n    background: #FFFFFF;\n    box-shadow: 0px 0px 4px rgb(243, 242, 242);\n}\n\n.tab-background {\n    background-color: white;\n    padding: 24px;\n    height: 70vh;\n    overflow-y: overlay;\n}\n\n#components-layout-demo-top-side .logo {\n    float: left;\n    width: 120px;\n    height: 31px;\n    margin: 16px 24px 16px 0;\n    background: rgba(255, 255, 255, 0.3);\n}\n\n.ant-row-rtl #components-layout-demo-top-side .logo {\n    float: right;\n    margin: 16px 0 16px 24px;\n}\n\n#components-layout-demo-custom-trigger .trigger {\n    padding: 0 24px;\n    font-size: 18px;\n    line-height: 64px;\n    cursor: pointer;\n    transition: color 0.3s;\n}\n\n#components-layout-demo-custom-trigger .trigger:hover {\n    color: #1890ff;\n}\n\n#components-layout-demo-custom-trigger .logo {\n    height: 32px;\n    margin: 16px;\n    background: rgba(255, 255, 255, 0.3);\n}\n\n.site-layout .site-layout-background {\n    background: #fff;\n}\n\n.details-layout {\n    height: 150px;\n    background-color: rgb(73, 84, 94);\n}\n\n.course-background {\n    background-image: url(\"./images/course.jpeg\");\n    /* background-position: center; */\n    background-size: cover;\n    background-repeat: no-repeat;\n}\n\n.b-icon {\n    height: 120px;\n    width: 120px;\n    position: absolute;\n    top: -4.3rem;\n    left: 50%;\n    transform: translateX(-50%);\n    display: block;\n    margin: auto;\n    border-radius: 50%;\n    border: 0.4rem solid #f7f7f7;\n    box-shadow: 1px 0px 10px rgb(0 0 0 / 30%);\n    overflow: hidden;\n    padding: 0 !important;\n    background: #fff;\n\n}\n\n.book-icon {\n    background-image: url(\"./images/book-icon.jpeg\");\n    background-size: cover;\n    background-repeat: no-repeat;\n}\n\n.b-background {\n    position: relative;\n    text-align: center;\n    min-height: 8rem;\n}\n\n.b-body {\n    position: relative;\n    padding-top: 4rem;\n}\n\n.radius-btn, .rounded-btn {\n    min-width: 100px;\n    border-radius: 20px;\n    font-size: 10px;\n    font-weight: 700;\n    text-align: center;\n    padding: 5px 10px;\n    /* border: 1px solid #ededed; */\n    box-shadow: 1px 1px 3px 0 rgba(145, 108, 108, 0.3);\n    text-transform: uppercase;\n}\n\n.active-btn, .open-btn, .delivered-btn, .paid-btn {\n    color: #0e8c30;\n    background-color: rgb(239, 255, 244);\n}\n\n.inactive-btn, .close-btn, .cancelled-btn, .unpaid-btn, .deleted-btn {\n    color: #d1011d;\n    background-color: #feeeed;\n}\n\n.details-area {\n    overflow: auto;\n    height: calc(100vh - 240px);\n}\n\n.site-page-header {\n    border-bottom: 1px solid rgb(235, 237, 240);\n}\n\n.inner-body {\n    margin-top: 25px;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    height: calc(100vh - 220px);\n}\n\n.single {\n    display: flex;\n    justify-content: space-between;\n    line-height: 20px;\n    margin-bottom: 10px;\n    color: \"gray\";\n    margin-left: 10px;\n}\n\n.single .info-desc {\n    width: 50%;\n    float: left;\n    text-align: left;\n}\n\n.info-name {\n    color: gray;\n    font-weight: 600;\n}\n\n\n/*new code*/\n\n.paginationBttns {\n    width: 100%;\n    height: 40px;\n    list-style: none;\n    display: flex;\n    justify-content: right;\n}\n\n.paginationBttns a {\n    padding: 10px;\n    margin: 1px;\n    border: 1px solid #2b2eff;\n    color: #2b2eff;\n    cursor: pointer;\n}\n\n.paginationBttns a:hover {\n    color: white;\n    background-color: #2b2eff;\n}\n\n.paginationActive a {\n    color: white;\n    background-color: #2b2eff;\n}\n\n.paginationDisabled a {\n    color: white;\n    background-color: gray;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
